import React from 'react'
import { Button, Paragraph, Separator } from '@fs/zion-ui'
import { Trans, useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'

export default function NamesHeaderV2() {
  const [t] = useTranslation()
  const { openOverlay } = useOverlayContext()
  const fullTextAttachFlowV2Flag = useFeatureFlag('rip_sharedImageViewer_fullTextAttachFlow_v2')

  const handleManageNames = () => {
    if (fullTextAttachFlowV2Flag.isOn) {
      openOverlay('manageNamesPanel')
    } else {
      openOverlay('dragNames')
    }
  }

  return (
    <>
      <Separator size="xs" />
      <Paragraph size="sm">
        <Trans i18nKey="select-person.instructions-v2">
          Select a name to view, edit, or delete. Use <strong>Manage Names</strong> to add or rearrange.
        </Trans>
      </Paragraph>
      <Separator size="xs" />
      <Button emphasis="medium" onClick={handleManageNames} data-testid="manage-names-button" linkName="Manage Names">
        {t('select-person.manage-names', 'MANAGE NAMES')}
      </Button>
    </>
  )
}
